export default (data, uniqueType) => {
  switch (uniqueType) {
    case 'batch':
      return [...new Set(data.map(j => {
        if (j.batch) {
          return j.batch.name
        }
      }).filter(x => x !== null))]
    case 'sourcecode':
      return [...new Set(data.map(j => {
        if (j.sourcecode) {
          return j.sourcecode.name
        }
      }).filter(x => x !== null))]
    case 'status':
      return [...new Set(data.map(j => {
        if (j.status) {
          return j.status.name
        }
      }).filter(x => x !== null))]
    case 'period':
      return [...new Set(data.map(j => {
        if (j.period) {
          return j.period.name
        }
      }).filter(x => x !== null))]
    case 'bank':
      return [...new Set(data.map(j => {
        if (j.bank) {
          return j.bank.name
        }
      }).filter(x => x !== null))]
    case 'transaction':
      return [...new Set(data.map(j => {
        if (j.transaction) {
          return j.transaction.name
        }
      }).filter(x => x !== null))]
    case 'vendor':
      return [...new Set(data.map(j => {
        if (j.vendor) {
          return j.vendor.name
        }
      }).filter(x => x !== null))]
    case 'type':
      return [...new Set(data.map(j => {
        if (j.type) {
          return j.type
        }
      }).filter(x => x !== null))]
    case 'entity_type':
      return [...new Set(data.map(j => {
        if (j.entity_type) {
          return j.entity_type
        }
      }).filter(x => x !== null))]
  }
  return []
}



// WEBPACK FOOTER //
// ./src/utils/helpers/GetUniqueValues.js